import React from "react";
import { withNamespaces } from "react-i18next";
import { useSelector } from "react-redux";
import Stepper from "@/components/Orders/DriverApp/Stepper";
import DriverTrackingMap from "@/components/Orders/DriverApp/DriverTrackingMap";

const DriverApp = ({ t, order }) => {
  const status = order?.status;
  let destinationLngLat = null;
  let branchLngLat = null;

  if (order?.customer_lat && order?.customer_lng) {
    destinationLngLat = {
      lat: order.customer_lat,
      lng: order.customer_lng,
    };
  } else if (order?.delivery_address__lat && order?.delivery_address__lng) {
    destinationLngLat = {
      lat: order.delivery_address__lat,
      lng: order.delivery_address__lng,
    };
  }

  if (order?.branch_lng && order?.branch_lat) {
    branchLngLat = {
      lat: order?.branch_lat,
      lng: order?.branch_lng,
    };
  }

  return (
    <div className="mt-5 p-2">
      <div className="mt-3" />

      {status === "Out for Delivery" && (
        <DriverTrackingMap
          orderTracking={order?.tracking_id}
          driverId={order?.shipping__driver_id}
          branchLocation={branchLngLat}
          status={status}
          destinationLocation={destinationLngLat}
        />
      )}
    </div>
  );
};

export default withNamespaces()(DriverApp);
